import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
type TranslateFn = (key: string, params?: Record<string, unknown>) => string;

interface DeletePlaceDialogProps {
    open: boolean;
    placeName?: string;
    onClose: () => void;
    onConfirm: () => void;
    isLoading: boolean;
    t: TranslateFn;
}

export const DeletePlaceDialog: React.FC<DeletePlaceDialogProps> = ({ open, placeName, onClose, onConfirm, isLoading, t }) => (
    <Dialog open={open} onClose={() => !isLoading && onClose()}>
        <DialogTitle>{t('places.modals.deleteConfirmation.title')}</DialogTitle>
        <DialogContent>
            <Typography>
                {t('places.modals.deleteConfirmation.message', { placeName: placeName || t('places.fields.name.unnamed') })}
            </Typography>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose} disabled={isLoading}>
                {t('buttons.cancel')}
            </Button>
            <Button variant="contained" color="error" onClick={onConfirm} disabled={isLoading}>
                {isLoading ? t('places.states.deleting') : t('places.actions.delete')}
            </Button>
        </DialogActions>
    </Dialog>
);
